import React from "react";
import { Redirect, Route } from "react-router";
import apiHelper from "../ApiHelper";

export const PermissionContext = React.createContext();

export const Roles = {
  SUPERADMIN: 1,
  CINEFAN_EDITOR: 2,
  CINEFAN_VIEWER: 3,
  HKNT_EDITOR: 4,
  HKNT_VIEWER: 5,
  HKIFF_EDITOR: 6,
  HKIFF_VIEWER: 7,
  HKIFF_MA_EDITOR: 8,
};

const PermissionProvider = (props) => {
  const [userPermissions, setUserPermissions] = React.useState(null);

  const getPermission = async () => {
    try {
      const result = await apiHelper.adminInfo();
      const roleIds = result.data.roles.map((detail) => detail.id);
      setUserPermissions(roleIds);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    getPermission();
  }, []);

  return (
    <PermissionContext.Provider value={{ userPermissions }}>
      {userPermissions ? props.children : null}
    </PermissionContext.Provider>
  );
};

export const withPermission =
  (WrapperComponent, permissions = [], editPermissions = []) =>
  (props) => {
    const { userPermissions } = React.useContext(PermissionContext);
    const hasPermission = userPermissions.some((r) => permissions.includes(r));
    const disabled =
      editPermissions.length > 0
        ? !userPermissions.some((r) => editPermissions.includes(r))
        : false;
    return hasPermission ? (
      <WrapperComponent {...{ disabled, ...props }} />
    ) : (
      <Route
        render={() => (
          <Redirect
            to={
              userPermissions.some((r) =>
                [
                  Roles.SUPERADMIN,
                  Roles.CINEFAN_EDITOR,
                  Roles.CINEFAN_VIEWER,
                ].includes(r)
              )
                ? "/cinefan"
                : userPermissions.some((r) =>
                    [Roles.HKNT_EDITOR, Roles.HKNT_VIEWER].includes(r)
                  )
                ? "/hknt"
                : userPermissions.some((r) =>
                    [Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER].includes(r)
                  )
                ? "/hkiff"
                : "/login"
            }
            exact
          />
        )}
      />
    );
  };

export default PermissionProvider;
